import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: flex-start;
`

export const Column = styled.div<{ isLastChild?: boolean; isFirstChild?: boolean }>`
  ${(props) => {
    if (props.isLastChild) {
      return 'margin-left: 20px;'
    }
    if (!props.isFirstChild) {
      return 'margin-left: 20px;'
    }
    return ''
  }}
`

export const Label = styled.span`
  font-size: 11px;
  font-weight: bold;
  line-height: 1.82;
  text-align: left;
  color: var(--color-neutral-500);
  text-transform: uppercase;
`

export const Value = styled.span`
  font-size: 13px;
  font-weight: var(--font-weight-regular);
  margin-left: 5px;
  line-height: 1.15;
  color: var(--color-contrast-black);
  text-transform: none;
`
